/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ProspectRouteImport } from './routes/prospect'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OauthConsentRouteImport } from './routes/oauth-consent'
import { Route as McpAuthCallbackRouteImport } from './routes/mcp-auth-callback'
import { Route as ManagementRouteImport } from './routes/management'
import { Route as LeadListsRouteImport } from './routes/lead-lists'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as FinderRouteImport } from './routes/finder'
import { Route as FindPeopleRouteImport } from './routes/find-people'
import { Route as ExtensionFeedbackRouteImport } from './routes/extension-feedback'
import { Route as ExtensionRouteImport } from './routes/extension'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CopilotRouteImport } from './routes/copilot'
import { Route as CluRouteImport } from './routes/clu'
import { Route as CancelledRouteImport } from './routes/cancelled'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SequencesIndexRouteImport } from './routes/sequences/index'
import { Route as PeopleIndexRouteImport } from './routes/people/index'
import { Route as ListsIndexRouteImport } from './routes/lists/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as CompaniesIndexRouteImport } from './routes/companies/index'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as SettingsTeamRouteImport } from './routes/settings/team'
import { Route as SettingsSecretsRouteImport } from './routes/settings/secrets'
import { Route as SettingsOrganizationRouteImport } from './routes/settings/organization'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsMemoryRouteImport } from './routes/settings/memory'
import { Route as SettingsEmailAccountsRouteImport } from './routes/settings/email-accounts'
import { Route as SettingsCallingRouteImport } from './routes/settings/calling'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SequencingSettingsRouteImport } from './routes/sequencing/settings'
import { Route as SequencesReviewRouteImport } from './routes/sequences/review'
import { Route as SequencesSequenceIdRouteImport } from './routes/sequences/$sequenceId'
import { Route as IntegrationsClaudeRouteImport } from './routes/integrations/claude'
import { Route as CrmFailedRouteImport } from './routes/crm/failed'
import { Route as CampaignsCampaignIdRouteImport } from './routes/campaigns/$campaignId'
import { Route as AuthSsoCallbackRouteImport } from './routes/auth/sso-callback'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as AppsumoUpgradeRouteImport } from './routes/appsumo/upgrade'
import { Route as AppsumoActivateRouteImport } from './routes/appsumo/activate'
import { Route as AgentsTemplatesRouteImport } from './routes/agents/templates'
import { Route as AgentsApprovalsRouteImport } from './routes/agents/approvals'
import { Route as AgentsAgentIdRouteImport } from './routes/agents/$agentId'
import { Route as PeoplePersonIdIndexRouteImport } from './routes/people/$personId/index'
import { Route as ListsListIdIndexRouteImport } from './routes/lists/$listId/index'
import { Route as CompaniesCompanyIdIndexRouteImport } from './routes/companies/$companyId/index'
import { Route as IntegrationsSixsenseMcpCallbackRouteImport } from './routes/integrations/sixsense-mcp.callback'
import { Route as IntegrationsNotionCallbackRouteImport } from './routes/integrations/notion.callback'
import { Route as IntegrationsGoogleCallbackRouteImport } from './routes/integrations/google.callback'
import { Route as IntegrationsGongCallbackRouteImport } from './routes/integrations/gong.callback'
import { Route as IntegrationsFirefliesCallbackRouteImport } from './routes/integrations/fireflies.callback'
import { Route as IntegrationsFathomCallbackRouteImport } from './routes/integrations/fathom.callback'
import { Route as IntegrationsAirtableCallbackRouteImport } from './routes/integrations/airtable.callback'
import { Route as IntegrationsCrmTypeSettingsRouteImport } from './routes/integrations/$crmType.settings'
import { Route as CluSharedConversationIdRouteImport } from './routes/clu_.shared.$conversationId'
import { Route as AgentsPlaysPlayIdRouteImport } from './routes/agents/plays.$playId'

const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProspectRoute = ProspectRouteImport.update({
  id: '/prospect',
  path: '/prospect',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth-consent',
  path: '/oauth-consent',
  getParentRoute: () => rootRouteImport,
} as any)
const McpAuthCallbackRoute = McpAuthCallbackRouteImport.update({
  id: '/mcp-auth-callback',
  path: '/mcp-auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementRoute = ManagementRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadListsRoute = LeadListsRouteImport.update({
  id: '/lead-lists',
  path: '/lead-lists',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const FinderRoute = FinderRouteImport.update({
  id: '/finder',
  path: '/finder',
  getParentRoute: () => rootRouteImport,
} as any)
const FindPeopleRoute = FindPeopleRouteImport.update({
  id: '/find-people',
  path: '/find-people',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionFeedbackRoute = ExtensionFeedbackRouteImport.update({
  id: '/extension-feedback',
  path: '/extension-feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionRoute = ExtensionRouteImport.update({
  id: '/extension',
  path: '/extension',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CopilotRoute = CopilotRouteImport.update({
  id: '/copilot',
  path: '/copilot',
  getParentRoute: () => rootRouteImport,
} as any)
const CluRoute = CluRouteImport.update({
  id: '/clu',
  path: '/clu',
  getParentRoute: () => rootRouteImport,
} as any)
const CancelledRoute = CancelledRouteImport.update({
  id: '/cancelled',
  path: '/cancelled',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencesIndexRoute = SequencesIndexRouteImport.update({
  id: '/sequences/',
  path: '/sequences/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsIndexRoute = ListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesIndexRoute = CompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/settings/team',
  path: '/settings/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSecretsRoute = SettingsSecretsRouteImport.update({
  id: '/settings/secrets',
  path: '/settings/secrets',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/settings/organization',
  path: '/settings/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMemoryRoute = SettingsMemoryRouteImport.update({
  id: '/settings/memory',
  path: '/settings/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEmailAccountsRoute = SettingsEmailAccountsRouteImport.update({
  id: '/settings/email-accounts',
  path: '/settings/email-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCallingRoute = SettingsCallingRouteImport.update({
  id: '/settings/calling',
  path: '/settings/calling',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/settings/appearance',
  path: '/settings/appearance',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencingSettingsRoute = SequencingSettingsRouteImport.update({
  id: '/sequencing/settings',
  path: '/sequencing/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencesReviewRoute = SequencesReviewRouteImport.update({
  id: '/sequences/review',
  path: '/sequences/review',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencesSequenceIdRoute = SequencesSequenceIdRouteImport.update({
  id: '/sequences/$sequenceId',
  path: '/sequences/$sequenceId',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsClaudeRoute = IntegrationsClaudeRouteImport.update({
  id: '/integrations/claude',
  path: '/integrations/claude',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmFailedRoute = CrmFailedRouteImport.update({
  id: '/crm/failed',
  path: '/crm/failed',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdRoute = CampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/auth/sso-callback',
  path: '/auth/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsumoUpgradeRoute = AppsumoUpgradeRouteImport.update({
  id: '/appsumo/upgrade',
  path: '/appsumo/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsumoActivateRoute = AppsumoActivateRouteImport.update({
  id: '/appsumo/activate',
  path: '/appsumo/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsTemplatesRoute = AgentsTemplatesRouteImport.update({
  id: '/agents/templates',
  path: '/agents/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsApprovalsRoute = AgentsApprovalsRouteImport.update({
  id: '/agents/approvals',
  path: '/agents/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const PeoplePersonIdIndexRoute = PeoplePersonIdIndexRouteImport.update({
  id: '/people/$personId/',
  path: '/people/$personId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsListIdIndexRoute = ListsListIdIndexRouteImport.update({
  id: '/lists/$listId/',
  path: '/lists/$listId/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdIndexRoute = CompaniesCompanyIdIndexRouteImport.update({
  id: '/companies/$companyId/',
  path: '/companies/$companyId/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSixsenseMcpCallbackRoute =
  IntegrationsSixsenseMcpCallbackRouteImport.update({
    id: '/integrations/sixsense-mcp/callback',
    path: '/integrations/sixsense-mcp/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsNotionCallbackRoute =
  IntegrationsNotionCallbackRouteImport.update({
    id: '/integrations/notion/callback',
    path: '/integrations/notion/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsGoogleCallbackRoute =
  IntegrationsGoogleCallbackRouteImport.update({
    id: '/integrations/google/callback',
    path: '/integrations/google/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsGongCallbackRoute =
  IntegrationsGongCallbackRouteImport.update({
    id: '/integrations/gong/callback',
    path: '/integrations/gong/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsFirefliesCallbackRoute =
  IntegrationsFirefliesCallbackRouteImport.update({
    id: '/integrations/fireflies/callback',
    path: '/integrations/fireflies/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsFathomCallbackRoute =
  IntegrationsFathomCallbackRouteImport.update({
    id: '/integrations/fathom/callback',
    path: '/integrations/fathom/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsAirtableCallbackRoute =
  IntegrationsAirtableCallbackRouteImport.update({
    id: '/integrations/airtable/callback',
    path: '/integrations/airtable/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsCrmTypeSettingsRoute =
  IntegrationsCrmTypeSettingsRouteImport.update({
    id: '/integrations/$crmType/settings',
    path: '/integrations/$crmType/settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const CluSharedConversationIdRoute = CluSharedConversationIdRouteImport.update({
  id: '/clu_/shared/$conversationId',
  path: '/clu/shared/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsPlaysPlayIdRoute = AgentsPlaysPlayIdRouteImport.update({
  id: '/agents/plays/$playId',
  path: '/agents/plays/$playId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/cancelled': typeof CancelledRoute
  '/clu': typeof CluRoute
  '/copilot': typeof CopilotRoute
  '/dashboard': typeof DashboardRoute
  '/extension': typeof ExtensionRoute
  '/extension-feedback': typeof ExtensionFeedbackRoute
  '/find-people': typeof FindPeopleRoute
  '/finder': typeof FinderRoute
  '/inbox': typeof InboxRoute
  '/lead-lists': typeof LeadListsRoute
  '/management': typeof ManagementRoute
  '/mcp-auth-callback': typeof McpAuthCallbackRoute
  '/oauth-consent': typeof OauthConsentRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/prospect': typeof ProspectRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/upgrade': typeof UpgradeRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/approvals': typeof AgentsApprovalsRoute
  '/agents/templates': typeof AgentsTemplatesRoute
  '/appsumo/activate': typeof AppsumoActivateRoute
  '/appsumo/upgrade': typeof AppsumoUpgradeRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/crm/failed': typeof CrmFailedRoute
  '/integrations/claude': typeof IntegrationsClaudeRoute
  '/sequences/$sequenceId': typeof SequencesSequenceIdRoute
  '/sequences/review': typeof SequencesReviewRoute
  '/sequencing/settings': typeof SequencingSettingsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/calling': typeof SettingsCallingRoute
  '/settings/email-accounts': typeof SettingsEmailAccountsRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/agents/': typeof AgentsIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/lists/': typeof ListsIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/sequences/': typeof SequencesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/agents/plays/$playId': typeof AgentsPlaysPlayIdRoute
  '/clu/shared/$conversationId': typeof CluSharedConversationIdRoute
  '/integrations/$crmType/settings': typeof IntegrationsCrmTypeSettingsRoute
  '/integrations/airtable/callback': typeof IntegrationsAirtableCallbackRoute
  '/integrations/fathom/callback': typeof IntegrationsFathomCallbackRoute
  '/integrations/fireflies/callback': typeof IntegrationsFirefliesCallbackRoute
  '/integrations/gong/callback': typeof IntegrationsGongCallbackRoute
  '/integrations/google/callback': typeof IntegrationsGoogleCallbackRoute
  '/integrations/notion/callback': typeof IntegrationsNotionCallbackRoute
  '/integrations/sixsense-mcp/callback': typeof IntegrationsSixsenseMcpCallbackRoute
  '/companies/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/lists/$listId/': typeof ListsListIdIndexRoute
  '/people/$personId/': typeof PeoplePersonIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/cancelled': typeof CancelledRoute
  '/clu': typeof CluRoute
  '/copilot': typeof CopilotRoute
  '/dashboard': typeof DashboardRoute
  '/extension': typeof ExtensionRoute
  '/extension-feedback': typeof ExtensionFeedbackRoute
  '/find-people': typeof FindPeopleRoute
  '/finder': typeof FinderRoute
  '/inbox': typeof InboxRoute
  '/lead-lists': typeof LeadListsRoute
  '/management': typeof ManagementRoute
  '/mcp-auth-callback': typeof McpAuthCallbackRoute
  '/oauth-consent': typeof OauthConsentRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/prospect': typeof ProspectRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/upgrade': typeof UpgradeRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/approvals': typeof AgentsApprovalsRoute
  '/agents/templates': typeof AgentsTemplatesRoute
  '/appsumo/activate': typeof AppsumoActivateRoute
  '/appsumo/upgrade': typeof AppsumoUpgradeRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/crm/failed': typeof CrmFailedRoute
  '/integrations/claude': typeof IntegrationsClaudeRoute
  '/sequences/$sequenceId': typeof SequencesSequenceIdRoute
  '/sequences/review': typeof SequencesReviewRoute
  '/sequencing/settings': typeof SequencingSettingsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/calling': typeof SettingsCallingRoute
  '/settings/email-accounts': typeof SettingsEmailAccountsRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/agents': typeof AgentsIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/companies': typeof CompaniesIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/lists': typeof ListsIndexRoute
  '/people': typeof PeopleIndexRoute
  '/sequences': typeof SequencesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/agents/plays/$playId': typeof AgentsPlaysPlayIdRoute
  '/clu/shared/$conversationId': typeof CluSharedConversationIdRoute
  '/integrations/$crmType/settings': typeof IntegrationsCrmTypeSettingsRoute
  '/integrations/airtable/callback': typeof IntegrationsAirtableCallbackRoute
  '/integrations/fathom/callback': typeof IntegrationsFathomCallbackRoute
  '/integrations/fireflies/callback': typeof IntegrationsFirefliesCallbackRoute
  '/integrations/gong/callback': typeof IntegrationsGongCallbackRoute
  '/integrations/google/callback': typeof IntegrationsGoogleCallbackRoute
  '/integrations/notion/callback': typeof IntegrationsNotionCallbackRoute
  '/integrations/sixsense-mcp/callback': typeof IntegrationsSixsenseMcpCallbackRoute
  '/companies/$companyId': typeof CompaniesCompanyIdIndexRoute
  '/lists/$listId': typeof ListsListIdIndexRoute
  '/people/$personId': typeof PeoplePersonIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/cancelled': typeof CancelledRoute
  '/clu': typeof CluRoute
  '/copilot': typeof CopilotRoute
  '/dashboard': typeof DashboardRoute
  '/extension': typeof ExtensionRoute
  '/extension-feedback': typeof ExtensionFeedbackRoute
  '/find-people': typeof FindPeopleRoute
  '/finder': typeof FinderRoute
  '/inbox': typeof InboxRoute
  '/lead-lists': typeof LeadListsRoute
  '/management': typeof ManagementRoute
  '/mcp-auth-callback': typeof McpAuthCallbackRoute
  '/oauth-consent': typeof OauthConsentRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/prospect': typeof ProspectRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/upgrade': typeof UpgradeRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/approvals': typeof AgentsApprovalsRoute
  '/agents/templates': typeof AgentsTemplatesRoute
  '/appsumo/activate': typeof AppsumoActivateRoute
  '/appsumo/upgrade': typeof AppsumoUpgradeRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/crm/failed': typeof CrmFailedRoute
  '/integrations/claude': typeof IntegrationsClaudeRoute
  '/sequences/$sequenceId': typeof SequencesSequenceIdRoute
  '/sequences/review': typeof SequencesReviewRoute
  '/sequencing/settings': typeof SequencingSettingsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/calling': typeof SettingsCallingRoute
  '/settings/email-accounts': typeof SettingsEmailAccountsRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/agents/': typeof AgentsIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/lists/': typeof ListsIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/sequences/': typeof SequencesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/agents/plays/$playId': typeof AgentsPlaysPlayIdRoute
  '/clu_/shared/$conversationId': typeof CluSharedConversationIdRoute
  '/integrations/$crmType/settings': typeof IntegrationsCrmTypeSettingsRoute
  '/integrations/airtable/callback': typeof IntegrationsAirtableCallbackRoute
  '/integrations/fathom/callback': typeof IntegrationsFathomCallbackRoute
  '/integrations/fireflies/callback': typeof IntegrationsFirefliesCallbackRoute
  '/integrations/gong/callback': typeof IntegrationsGongCallbackRoute
  '/integrations/google/callback': typeof IntegrationsGoogleCallbackRoute
  '/integrations/notion/callback': typeof IntegrationsNotionCallbackRoute
  '/integrations/sixsense-mcp/callback': typeof IntegrationsSixsenseMcpCallbackRoute
  '/companies/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/lists/$listId/': typeof ListsListIdIndexRoute
  '/people/$personId/': typeof PeoplePersonIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/cancelled'
    | '/clu'
    | '/copilot'
    | '/dashboard'
    | '/extension'
    | '/extension-feedback'
    | '/find-people'
    | '/finder'
    | '/inbox'
    | '/lead-lists'
    | '/management'
    | '/mcp-auth-callback'
    | '/oauth-consent'
    | '/onboarding'
    | '/plans'
    | '/prospect'
    | '/reports'
    | '/search'
    | '/tasks'
    | '/upgrade'
    | '/agents/$agentId'
    | '/agents/approvals'
    | '/agents/templates'
    | '/appsumo/activate'
    | '/appsumo/upgrade'
    | '/auth/error'
    | '/auth/login'
    | '/auth/register'
    | '/auth/sso-callback'
    | '/campaigns/$campaignId'
    | '/crm/failed'
    | '/integrations/claude'
    | '/sequences/$sequenceId'
    | '/sequences/review'
    | '/sequencing/settings'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/calling'
    | '/settings/email-accounts'
    | '/settings/memory'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/secrets'
    | '/settings/team'
    | '/agents/'
    | '/campaigns/'
    | '/companies/'
    | '/integrations/'
    | '/lists/'
    | '/people/'
    | '/sequences/'
    | '/settings/'
    | '/agents/plays/$playId'
    | '/clu/shared/$conversationId'
    | '/integrations/$crmType/settings'
    | '/integrations/airtable/callback'
    | '/integrations/fathom/callback'
    | '/integrations/fireflies/callback'
    | '/integrations/gong/callback'
    | '/integrations/google/callback'
    | '/integrations/notion/callback'
    | '/integrations/sixsense-mcp/callback'
    | '/companies/$companyId/'
    | '/lists/$listId/'
    | '/people/$personId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/cancelled'
    | '/clu'
    | '/copilot'
    | '/dashboard'
    | '/extension'
    | '/extension-feedback'
    | '/find-people'
    | '/finder'
    | '/inbox'
    | '/lead-lists'
    | '/management'
    | '/mcp-auth-callback'
    | '/oauth-consent'
    | '/onboarding'
    | '/plans'
    | '/prospect'
    | '/reports'
    | '/search'
    | '/tasks'
    | '/upgrade'
    | '/agents/$agentId'
    | '/agents/approvals'
    | '/agents/templates'
    | '/appsumo/activate'
    | '/appsumo/upgrade'
    | '/auth/error'
    | '/auth/login'
    | '/auth/register'
    | '/auth/sso-callback'
    | '/campaigns/$campaignId'
    | '/crm/failed'
    | '/integrations/claude'
    | '/sequences/$sequenceId'
    | '/sequences/review'
    | '/sequencing/settings'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/calling'
    | '/settings/email-accounts'
    | '/settings/memory'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/secrets'
    | '/settings/team'
    | '/agents'
    | '/campaigns'
    | '/companies'
    | '/integrations'
    | '/lists'
    | '/people'
    | '/sequences'
    | '/settings'
    | '/agents/plays/$playId'
    | '/clu/shared/$conversationId'
    | '/integrations/$crmType/settings'
    | '/integrations/airtable/callback'
    | '/integrations/fathom/callback'
    | '/integrations/fireflies/callback'
    | '/integrations/gong/callback'
    | '/integrations/google/callback'
    | '/integrations/notion/callback'
    | '/integrations/sixsense-mcp/callback'
    | '/companies/$companyId'
    | '/lists/$listId'
    | '/people/$personId'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/cancelled'
    | '/clu'
    | '/copilot'
    | '/dashboard'
    | '/extension'
    | '/extension-feedback'
    | '/find-people'
    | '/finder'
    | '/inbox'
    | '/lead-lists'
    | '/management'
    | '/mcp-auth-callback'
    | '/oauth-consent'
    | '/onboarding'
    | '/plans'
    | '/prospect'
    | '/reports'
    | '/search'
    | '/tasks'
    | '/upgrade'
    | '/agents/$agentId'
    | '/agents/approvals'
    | '/agents/templates'
    | '/appsumo/activate'
    | '/appsumo/upgrade'
    | '/auth/error'
    | '/auth/login'
    | '/auth/register'
    | '/auth/sso-callback'
    | '/campaigns/$campaignId'
    | '/crm/failed'
    | '/integrations/claude'
    | '/sequences/$sequenceId'
    | '/sequences/review'
    | '/sequencing/settings'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/calling'
    | '/settings/email-accounts'
    | '/settings/memory'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/secrets'
    | '/settings/team'
    | '/agents/'
    | '/campaigns/'
    | '/companies/'
    | '/integrations/'
    | '/lists/'
    | '/people/'
    | '/sequences/'
    | '/settings/'
    | '/agents/plays/$playId'
    | '/clu_/shared/$conversationId'
    | '/integrations/$crmType/settings'
    | '/integrations/airtable/callback'
    | '/integrations/fathom/callback'
    | '/integrations/fireflies/callback'
    | '/integrations/gong/callback'
    | '/integrations/google/callback'
    | '/integrations/notion/callback'
    | '/integrations/sixsense-mcp/callback'
    | '/companies/$companyId/'
    | '/lists/$listId/'
    | '/people/$personId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  ApiKeysRoute: typeof ApiKeysRoute
  CancelledRoute: typeof CancelledRoute
  CluRoute: typeof CluRoute
  CopilotRoute: typeof CopilotRoute
  DashboardRoute: typeof DashboardRoute
  ExtensionRoute: typeof ExtensionRoute
  ExtensionFeedbackRoute: typeof ExtensionFeedbackRoute
  FindPeopleRoute: typeof FindPeopleRoute
  FinderRoute: typeof FinderRoute
  InboxRoute: typeof InboxRoute
  LeadListsRoute: typeof LeadListsRoute
  ManagementRoute: typeof ManagementRoute
  McpAuthCallbackRoute: typeof McpAuthCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OnboardingRoute: typeof OnboardingRoute
  PlansRoute: typeof PlansRoute
  ProspectRoute: typeof ProspectRoute
  ReportsRoute: typeof ReportsRoute
  SearchRoute: typeof SearchRoute
  TasksRoute: typeof TasksRoute
  UpgradeRoute: typeof UpgradeRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  AgentsApprovalsRoute: typeof AgentsApprovalsRoute
  AgentsTemplatesRoute: typeof AgentsTemplatesRoute
  AppsumoActivateRoute: typeof AppsumoActivateRoute
  AppsumoUpgradeRoute: typeof AppsumoUpgradeRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  CampaignsCampaignIdRoute: typeof CampaignsCampaignIdRoute
  CrmFailedRoute: typeof CrmFailedRoute
  IntegrationsClaudeRoute: typeof IntegrationsClaudeRoute
  SequencesSequenceIdRoute: typeof SequencesSequenceIdRoute
  SequencesReviewRoute: typeof SequencesReviewRoute
  SequencingSettingsRoute: typeof SequencingSettingsRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsCallingRoute: typeof SettingsCallingRoute
  SettingsEmailAccountsRoute: typeof SettingsEmailAccountsRoute
  SettingsMemoryRoute: typeof SettingsMemoryRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsSecretsRoute: typeof SettingsSecretsRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  CompaniesIndexRoute: typeof CompaniesIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  ListsIndexRoute: typeof ListsIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  SequencesIndexRoute: typeof SequencesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  AgentsPlaysPlayIdRoute: typeof AgentsPlaysPlayIdRoute
  CluSharedConversationIdRoute: typeof CluSharedConversationIdRoute
  IntegrationsCrmTypeSettingsRoute: typeof IntegrationsCrmTypeSettingsRoute
  IntegrationsAirtableCallbackRoute: typeof IntegrationsAirtableCallbackRoute
  IntegrationsFathomCallbackRoute: typeof IntegrationsFathomCallbackRoute
  IntegrationsFirefliesCallbackRoute: typeof IntegrationsFirefliesCallbackRoute
  IntegrationsGongCallbackRoute: typeof IntegrationsGongCallbackRoute
  IntegrationsGoogleCallbackRoute: typeof IntegrationsGoogleCallbackRoute
  IntegrationsNotionCallbackRoute: typeof IntegrationsNotionCallbackRoute
  IntegrationsSixsenseMcpCallbackRoute: typeof IntegrationsSixsenseMcpCallbackRoute
  CompaniesCompanyIdIndexRoute: typeof CompaniesCompanyIdIndexRoute
  ListsListIdIndexRoute: typeof ListsListIdIndexRoute
  PeoplePersonIdIndexRoute: typeof PeoplePersonIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prospect': {
      id: '/prospect'
      path: '/prospect'
      fullPath: '/prospect'
      preLoaderRoute: typeof ProspectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-consent': {
      id: '/oauth-consent'
      path: '/oauth-consent'
      fullPath: '/oauth-consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp-auth-callback': {
      id: '/mcp-auth-callback'
      path: '/mcp-auth-callback'
      fullPath: '/mcp-auth-callback'
      preLoaderRoute: typeof McpAuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management': {
      id: '/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof ManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lead-lists': {
      id: '/lead-lists'
      path: '/lead-lists'
      fullPath: '/lead-lists'
      preLoaderRoute: typeof LeadListsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finder': {
      id: '/finder'
      path: '/finder'
      fullPath: '/finder'
      preLoaderRoute: typeof FinderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/find-people': {
      id: '/find-people'
      path: '/find-people'
      fullPath: '/find-people'
      preLoaderRoute: typeof FindPeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extension-feedback': {
      id: '/extension-feedback'
      path: '/extension-feedback'
      fullPath: '/extension-feedback'
      preLoaderRoute: typeof ExtensionFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extension': {
      id: '/extension'
      path: '/extension'
      fullPath: '/extension'
      preLoaderRoute: typeof ExtensionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copilot': {
      id: '/copilot'
      path: '/copilot'
      fullPath: '/copilot'
      preLoaderRoute: typeof CopilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clu': {
      id: '/clu'
      path: '/clu'
      fullPath: '/clu'
      preLoaderRoute: typeof CluRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancelled': {
      id: '/cancelled'
      path: '/cancelled'
      fullPath: '/cancelled'
      preLoaderRoute: typeof CancelledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequences/': {
      id: '/sequences/'
      path: '/sequences'
      fullPath: '/sequences/'
      preLoaderRoute: typeof SequencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/': {
      id: '/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof ListsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/': {
      id: '/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof CompaniesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/secrets': {
      id: '/settings/secrets'
      path: '/settings/secrets'
      fullPath: '/settings/secrets'
      preLoaderRoute: typeof SettingsSecretsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/memory': {
      id: '/settings/memory'
      path: '/settings/memory'
      fullPath: '/settings/memory'
      preLoaderRoute: typeof SettingsMemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/email-accounts': {
      id: '/settings/email-accounts'
      path: '/settings/email-accounts'
      fullPath: '/settings/email-accounts'
      preLoaderRoute: typeof SettingsEmailAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/calling': {
      id: '/settings/calling'
      path: '/settings/calling'
      fullPath: '/settings/calling'
      preLoaderRoute: typeof SettingsCallingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequencing/settings': {
      id: '/sequencing/settings'
      path: '/sequencing/settings'
      fullPath: '/sequencing/settings'
      preLoaderRoute: typeof SequencingSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequences/review': {
      id: '/sequences/review'
      path: '/sequences/review'
      fullPath: '/sequences/review'
      preLoaderRoute: typeof SequencesReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequences/$sequenceId': {
      id: '/sequences/$sequenceId'
      path: '/sequences/$sequenceId'
      fullPath: '/sequences/$sequenceId'
      preLoaderRoute: typeof SequencesSequenceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/claude': {
      id: '/integrations/claude'
      path: '/integrations/claude'
      fullPath: '/integrations/claude'
      preLoaderRoute: typeof IntegrationsClaudeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/failed': {
      id: '/crm/failed'
      path: '/crm/failed'
      fullPath: '/crm/failed'
      preLoaderRoute: typeof CrmFailedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId': {
      id: '/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof CampaignsCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sso-callback': {
      id: '/auth/sso-callback'
      path: '/auth/sso-callback'
      fullPath: '/auth/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appsumo/upgrade': {
      id: '/appsumo/upgrade'
      path: '/appsumo/upgrade'
      fullPath: '/appsumo/upgrade'
      preLoaderRoute: typeof AppsumoUpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appsumo/activate': {
      id: '/appsumo/activate'
      path: '/appsumo/activate'
      fullPath: '/appsumo/activate'
      preLoaderRoute: typeof AppsumoActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/templates': {
      id: '/agents/templates'
      path: '/agents/templates'
      fullPath: '/agents/templates'
      preLoaderRoute: typeof AgentsTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/approvals': {
      id: '/agents/approvals'
      path: '/agents/approvals'
      fullPath: '/agents/approvals'
      preLoaderRoute: typeof AgentsApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$personId/': {
      id: '/people/$personId/'
      path: '/people/$personId'
      fullPath: '/people/$personId/'
      preLoaderRoute: typeof PeoplePersonIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/$listId/': {
      id: '/lists/$listId/'
      path: '/lists/$listId'
      fullPath: '/lists/$listId/'
      preLoaderRoute: typeof ListsListIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$companyId/': {
      id: '/companies/$companyId/'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof CompaniesCompanyIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/sixsense-mcp/callback': {
      id: '/integrations/sixsense-mcp/callback'
      path: '/integrations/sixsense-mcp/callback'
      fullPath: '/integrations/sixsense-mcp/callback'
      preLoaderRoute: typeof IntegrationsSixsenseMcpCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/notion/callback': {
      id: '/integrations/notion/callback'
      path: '/integrations/notion/callback'
      fullPath: '/integrations/notion/callback'
      preLoaderRoute: typeof IntegrationsNotionCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/google/callback': {
      id: '/integrations/google/callback'
      path: '/integrations/google/callback'
      fullPath: '/integrations/google/callback'
      preLoaderRoute: typeof IntegrationsGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/gong/callback': {
      id: '/integrations/gong/callback'
      path: '/integrations/gong/callback'
      fullPath: '/integrations/gong/callback'
      preLoaderRoute: typeof IntegrationsGongCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/fireflies/callback': {
      id: '/integrations/fireflies/callback'
      path: '/integrations/fireflies/callback'
      fullPath: '/integrations/fireflies/callback'
      preLoaderRoute: typeof IntegrationsFirefliesCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/fathom/callback': {
      id: '/integrations/fathom/callback'
      path: '/integrations/fathom/callback'
      fullPath: '/integrations/fathom/callback'
      preLoaderRoute: typeof IntegrationsFathomCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/airtable/callback': {
      id: '/integrations/airtable/callback'
      path: '/integrations/airtable/callback'
      fullPath: '/integrations/airtable/callback'
      preLoaderRoute: typeof IntegrationsAirtableCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/$crmType/settings': {
      id: '/integrations/$crmType/settings'
      path: '/integrations/$crmType/settings'
      fullPath: '/integrations/$crmType/settings'
      preLoaderRoute: typeof IntegrationsCrmTypeSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clu_/shared/$conversationId': {
      id: '/clu_/shared/$conversationId'
      path: '/clu/shared/$conversationId'
      fullPath: '/clu/shared/$conversationId'
      preLoaderRoute: typeof CluSharedConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/plays/$playId': {
      id: '/agents/plays/$playId'
      path: '/agents/plays/$playId'
      fullPath: '/agents/plays/$playId'
      preLoaderRoute: typeof AgentsPlaysPlayIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  ApiKeysRoute: ApiKeysRoute,
  CancelledRoute: CancelledRoute,
  CluRoute: CluRoute,
  CopilotRoute: CopilotRoute,
  DashboardRoute: DashboardRoute,
  ExtensionRoute: ExtensionRoute,
  ExtensionFeedbackRoute: ExtensionFeedbackRoute,
  FindPeopleRoute: FindPeopleRoute,
  FinderRoute: FinderRoute,
  InboxRoute: InboxRoute,
  LeadListsRoute: LeadListsRoute,
  ManagementRoute: ManagementRoute,
  McpAuthCallbackRoute: McpAuthCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
  OnboardingRoute: OnboardingRoute,
  PlansRoute: PlansRoute,
  ProspectRoute: ProspectRoute,
  ReportsRoute: ReportsRoute,
  SearchRoute: SearchRoute,
  TasksRoute: TasksRoute,
  UpgradeRoute: UpgradeRoute,
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  AgentsApprovalsRoute: AgentsApprovalsRoute,
  AgentsTemplatesRoute: AgentsTemplatesRoute,
  AppsumoActivateRoute: AppsumoActivateRoute,
  AppsumoUpgradeRoute: AppsumoUpgradeRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  CampaignsCampaignIdRoute: CampaignsCampaignIdRoute,
  CrmFailedRoute: CrmFailedRoute,
  IntegrationsClaudeRoute: IntegrationsClaudeRoute,
  SequencesSequenceIdRoute: SequencesSequenceIdRoute,
  SequencesReviewRoute: SequencesReviewRoute,
  SequencingSettingsRoute: SequencingSettingsRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsCallingRoute: SettingsCallingRoute,
  SettingsEmailAccountsRoute: SettingsEmailAccountsRoute,
  SettingsMemoryRoute: SettingsMemoryRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsSecretsRoute: SettingsSecretsRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  CompaniesIndexRoute: CompaniesIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  ListsIndexRoute: ListsIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  SequencesIndexRoute: SequencesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  AgentsPlaysPlayIdRoute: AgentsPlaysPlayIdRoute,
  CluSharedConversationIdRoute: CluSharedConversationIdRoute,
  IntegrationsCrmTypeSettingsRoute: IntegrationsCrmTypeSettingsRoute,
  IntegrationsAirtableCallbackRoute: IntegrationsAirtableCallbackRoute,
  IntegrationsFathomCallbackRoute: IntegrationsFathomCallbackRoute,
  IntegrationsFirefliesCallbackRoute: IntegrationsFirefliesCallbackRoute,
  IntegrationsGongCallbackRoute: IntegrationsGongCallbackRoute,
  IntegrationsGoogleCallbackRoute: IntegrationsGoogleCallbackRoute,
  IntegrationsNotionCallbackRoute: IntegrationsNotionCallbackRoute,
  IntegrationsSixsenseMcpCallbackRoute: IntegrationsSixsenseMcpCallbackRoute,
  CompaniesCompanyIdIndexRoute: CompaniesCompanyIdIndexRoute,
  ListsListIdIndexRoute: ListsListIdIndexRoute,
  PeoplePersonIdIndexRoute: PeoplePersonIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
